import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ll_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!["/", "/login", "/signup"].includes(path)) {
        localStorage.removeItem("ll_token");
        localStorage.removeItem("ll_user");
        localStorage.removeItem("ll_tenant");
        if (path.startsWith("/client")) sessionStorage.setItem("ll_after_login", path + window.location.search);
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const downloadFile = async (url, filename) => {
  const res = await api.get(url, { responseType: "blob" });
  const blob = new Blob([res.data]);
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

/**
 * Opens a backend file in a new browser tab. Fetches with the auth header
 * (image/anchor tags can't send Authorization headers), wraps the response in
 * a Blob URL, and points a new window at it. Caller receives the blob URL so
 * it can revoke it later if needed.
 */
export const openFile = async (url, mediaType) => {
  const res = await api.get(url, { responseType: "blob" });
  const blob = new Blob([res.data], mediaType ? { type: mediaType } : undefined);
  const blobUrl = window.URL.createObjectURL(blob);
  window.open(blobUrl, "_blank", "noopener,noreferrer");
  // Revoke after a delay so the new tab has a chance to load.
  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60_000);
  return blobUrl;
};
